import RefDataCrudPage from './RefDataCrudPage'
import { jobDefinitionsApi } from '../api/lookupApi'

export default function JobDefinitionsPage() {
  return <RefDataCrudPage api={jobDefinitionsApi} i18nPrefix="optionDefs.jobDefinitions" />
}
